import React from "react"

import Button from "../Button/button"

import "./quoteBlock.scss"

const QuoteBlock = props => {
  return (
    <div className="quote-block">
      <div className="container">
        <div className="quote-block__content">
          <h2 className="headline">{props.headline}</h2>
          <div
            className="body-copy"
            dangerouslySetInnerHTML={{ __html: props.body_copy }}
          />
          {props.button.length !== 0 && (
            <div className="button__container">
              {props.button.map((data, index) => {
                return (
                  <Button
                    key={index}
                    button_link={data.button_link.href}
                    button_link_type={data.button_link_type}
                    button_text={data.button_text}
                    button_color={data.button_color}
                    button_type={data.button_type}
                    className={
                      data.button_type === "square button" && "button__sign-up"
                    }
                    color_theme={props.color_theme}
                    text_color={data.text_color}
                  />
                )
              })}
            </div>
          )}
        </div>
        <div
          className="quote-block__quote"
          dangerouslySetInnerHTML={{ __html: props.quote }}
        ></div>
      </div>
    </div>
  )
}

export default QuoteBlock
